var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 5H0V25.0002H30V5Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 5H13.125V13.125H0V16.875H13.125V24.9999H16.875V16.875H30V13.125H16.875V5Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 18.4785L30.0009 22.3267V18.4785H23.0742Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2617 18.4785L30.0009 25.0002V23.1561L21.5813 18.4785H18.2617Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8739 24.9998L18.2617 20.2148V24.9998H26.8739Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2617 18.4785L30.0009 25.0002V23.1561L21.5813 18.4785H18.2617Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2617 18.4785L30.0009 25.0002V23.1561L21.5813 18.4785H18.2617Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29342 18.4785L0 21.4193V18.4785H5.29342Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7377 19.3086V25.001H1.49219L11.7377 19.3086Z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41951 18.4785L0 23.1561V25.0002L11.7391 18.4785H8.41951Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92666 11.522L0 7.67383V11.522H6.92666Z",
    fill: "#0052B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7391 11.5217L0 5V6.84418L8.41951 11.5217H11.7391Z",
    fill: "#0052B4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12891 5L11.7411 9.785V5H3.12891Z",
    fill: "#0052B4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7391 11.5217L0 5V6.84418L8.41951 11.5217H11.7391Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7391 11.5217L0 5V6.84418L8.41951 11.5217H11.7391Z",
    fill: "#D80027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.707 11.5209L30.0005 8.58008V11.5209H24.707Z",
    fill: "#0052B4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2617 10.6924V5H28.5072L18.2617 10.6924Z",
    fill: "#0052B4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5813 11.5217L30.0009 6.84418V5L18.2617 11.5217H21.5813Z",
    fill: "#D80027"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/English.77c693e8.svg";
export { ForwardRef as ReactComponent };